<template>
  <div class="activity-page activity-page--newbie">
    <div class="decor decor--a" />
    <div class="decor decor--b" />
    <div class="decor decor--c" />

    <header class="brand">
      <span class="brand__logo">G</span>
      <span class="brand__name">Go Trust</span>
    </header>

    <main class="main">
      <h1 class="title">新用户首单优惠</h1>
      <p class="subtitle">恭喜你获得新人专属福利</p>

      <div class="coupon">
        <div class="coupon__left">
          <span class="coupon__dot" v-for="n in 5" :key="n" />
        </div>
        <div class="coupon__dash" />
        <div class="coupon__right">
          <p class="coupon__amount">
            <span class="coupon__yen">¥</span>{{ amountText }}
          </p>
          <p class="coupon__label">{{ couponLabel }}</p>
        </div>
      </div>

      <button
        type="button"
        class="cta"
        :disabled="claiming"
        @click="onClaim"
      >
        {{ claiming ? '领取中…' : '立即领取' }}
      </button>

      <section class="rules">
        <h2 class="rules__title">活动规则</h2>
        <p class="rules__text">{{ rulesText }}</p>
      </section>

      <p v-if="toast" class="toast">{{ toast }}</p>
    </main>
  </div>
</template>

<script>
import { claimFirstCoupon, fetchCoupons } from '../api/activity'
import {
  getToken,
  isInApp,
  requireLogin,
  setToken,
} from '../utils/appBridge'

export default {
  name: 'ActivityNewbiePage',
  data() {
    return {
      amountText: '50',
      couponLabel: '无门槛券',
      rulesText: '抵扣券可叠加，具体使用张数以下单页为准。活动有效期以页面展示为准。',
      claiming: false,
      toast: '',
    }
  },
  created() {
    this.bootstrap()
  },
  methods: {
    async bootstrap() {
      const t = getToken()
      if (t) setToken(t)

      const token = getToken()
      if (!token) return
      try {
        const list = await fetchCoupons(token)
        const arr = Array.isArray(list) ? list : []
        const target = arr[0]
        if (target) {
          const amt = String(target.amount ?? '50').replace(/\.00$/, '')
          this.amountText = amt
          this.couponLabel =
            Number(target.mov) > 0 ? `满${target.mov}可用` : '无门槛券'
          if (target.description) this.rulesText = String(target.description)
        }
      } catch (_) {
        // 未登录或列表失败时保留默认展示
      }
    },
    showToast(msg) {
      this.toast = msg
      clearTimeout(this._toastTimer)
      this._toastTimer = setTimeout(() => {
        this.toast = ''
      }, 2200)
    },
    async onClaim() {
      let token = getToken()
      if (!token) {
        if (isInApp()) {
          requireLogin()
          this.showToast('请先登录')
        } else {
          this.showToast('请在 App 内打开并登录后领取')
        }
        return
      }
      this.claiming = true
      try {
        await claimFirstCoupon(token)
        this.showToast('领取成功')
      } catch (e) {
        const msg = e?.message || '领取失败'
        if (/登录|鉴权|401|token|未授权/i.test(msg)) {
          requireLogin()
        }
        this.showToast(msg)
      } finally {
        this.claiming = false
      }
    },
  },
}
</script>

<style scoped>
.activity-page {
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  background: #f3f0ea;
  color: #3d3428;
  padding: 20px 20px 40px;
  box-sizing: border-box;
}

.decor {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
}
.decor--a {
  width: 220px;
  height: 220px;
  right: -60px;
  top: 40px;
  background: rgba(241, 122, 43, 0.12);
}
.decor--b {
  width: 160px;
  height: 160px;
  left: -50px;
  top: 220px;
  background: rgba(61, 52, 40, 0.06);
}
.decor--c {
  width: 120px;
  height: 120px;
  right: 40px;
  bottom: 120px;
  background: rgba(241, 122, 43, 0.08);
}

.brand {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 28px;
}
.brand__logo {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #f17a2b;
  color: #fff;
  font-weight: 800;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.brand__name {
  font-size: 16px;
  font-weight: 700;
}

.main {
  position: relative;
  z-index: 1;
  max-width: 420px;
  margin: 0 auto;
  text-align: center;
}

.title {
  font-size: 28px;
  font-weight: 800;
  letter-spacing: 0.5px;
}
.subtitle {
  margin-top: 8px;
  font-size: 14px;
  color: #8a7f72;
}

.coupon {
  margin: 28px auto 0;
  width: 100%;
  max-width: 320px;
  height: 108px;
  display: flex;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 10px 28px rgba(241, 122, 43, 0.18);
}
.coupon__left {
  width: 56px;
  background: #f17a2b;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.coupon__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.85);
}
.coupon__dash {
  width: 0;
  border-left: 2px dashed rgba(241, 122, 43, 0.35);
  background: #fff;
}
.coupon__right {
  flex: 1;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.coupon__amount {
  color: #f17a2b;
  font-size: 42px;
  font-weight: 800;
  line-height: 1;
}
.coupon__yen {
  font-size: 22px;
  margin-right: 2px;
}
.coupon__label {
  margin-top: 6px;
  font-size: 14px;
  color: #8a7f72;
}

.cta {
  margin-top: 28px;
  width: 100%;
  max-width: 320px;
  height: 48px;
  border: none;
  border-radius: 24px;
  background: #f17a2b;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
}
.cta:disabled {
  opacity: 0.65;
}

.rules {
  margin-top: 36px;
  text-align: left;
  background: rgba(255, 255, 255, 0.55);
  border-radius: 14px;
  padding: 16px;
}
.rules__title {
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 8px;
}
.rules__text {
  font-size: 13px;
  line-height: 1.6;
  color: #8a7f72;
}

.toast {
  position: fixed;
  left: 50%;
  bottom: 48px;
  transform: translateX(-50%);
  background: rgba(61, 52, 40, 0.92);
  color: #fff;
  padding: 10px 16px;
  border-radius: 20px;
  font-size: 13px;
  z-index: 20;
  white-space: nowrap;
}
</style>
